var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLogin)?_c('v-footer',{staticClass:"footer-area",attrs:{"app":""}},[_c('p',{attrs:{"id":"copyright"}},[_vm._v("© "+_vm._s(new Date().getFullYear())+" 一般社団法人全国建設発生土リサイクル協会")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }